import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { AuthService } from '../_services/auth_service';
import { HttpResponse } from '@angular/common/http';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html',
})
export class AppSidebarComponent implements OnInit, OnDestroy {
    timeout: any = null;

    /* per il blocco utente del drawer mobile (scheda _1 pag. 20) */
    public nome: string = '';
    public ruolo: string = '';

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef,
        private authService: AuthService
    ) {}

    ngOnInit() {
        this.authService.getUserData().subscribe({
            next: (response: HttpResponse<any>) => {
                this.nome = response.body.nome;
                this.ruolo = response.body.ruolo;
            }
        });
    }


    resetOverlay() {
        if (this.layoutService.state.overlayMenuActive) {
            this.layoutService.state.overlayMenuActive = false;
        }
    }

    ngOnDestroy() {
        this.resetOverlay();
    }
}
